import { convertStyleData } from '@utils/tools';
import { customEvent } from '@utils/customEvent';

import './PictureCustomComponent.less';

export default function PictureCustomComponent(props) {
  /**
   * 传入数据
   */ 
  const data = props.data;                    // 组件数据
  const detailData = props.detailData;        // 详情页数据
  const dynamicData = props.dynamicData;      // 动态数据
  /**
   * 组件配置对象
   */  
  const customFeature = data.customFeature;
  /**
   * 样式数据处理
   */
  let styleObj = convertStyleData(data.style);
  /**
   * 组件内容处理
   */   
  let content = data.content;
  const segment = data.customFeature.segment; // 已绑定字段
  let realValue = null;
  // 是否有绑定字段
  if (segment) {
    if (detailData && detailData[segment]) {
      realValue = detailData[segment];    // 当前组件处于详情页数据并已绑定某字段
    } else if (dynamicData && dynamicData[segment]) {
      realValue = dynamicData[segment];   // 当前组件有动态数据并已绑定某字段
    }
    if (customFeature.action === 'call' && customFeature.phoneDisplayContent === 'static') {
      // 拨打电话点击事件： 电话号码设为手动填写并且显示内容设为组件内容
      content = content;
    } else {
      // 有动态数据则赋值给content
      content = realValue;
    }
  }
  if (!Array.isArray(content)) {              // 图片数据 string[] / string, 将不为数组的数据处理为数组
    content = [content];
  }
  /**
   * 返回组件
   */
  return (
    content.map((url, index) => (
      <div className="custom-component picture" key={index} style={styleObj} onClick={() => customEvent({customFeature, realValue})}>
        {
          // 是否设为纯色
          !customFeature.backgroundType && (
            <img src={url} />
          )
        }
      </div>
    ))
  );
}


// WEBPACK FOOTER //
// ./src/custom-component/picture-custom-component/PictureCustomComponent.jsx